/* Duurzaamheidspagina: alleen het meten van kliks.

   De pagina werkt volledig zonder JavaScript; alles staat server-side in
   de HTML. Wat hier gebeurt is het doorgeven van drie soorten kliks aan
   de datalayer, zodat te zien is welk deel van de pagina mensen verder
   brengt: de EVC-collectie, de twee Trees for All-links en de
   blogkaarten.

   Een delegatie op document en geen listener per link. Er staan
   hoogstens een handvol links, maar de blogkaarten zijn theme-blocks en
   kunnen in de editor bijkomen; met delegatie doet een nieuwe kaart
   vanzelf mee zonder dat hier iets bij hoeft. */
(function () {
  'use strict';

  /* Twee attributen, want de blogkaarten komen uit de gedeelde
     kaartensectie en die zet zijn eigen attribuut. Beide vangen we op,
     zodat de kaarten meetellen zonder de gedeelde sectie aan te passen
     voor iets dat alleen deze pagina wil.

     Dat het tweede attribuut breed is, kan hier: dit bestand wordt
     alleen ingeladen door de duurzaamheidssecties, dus het draait
     nergens anders. Komt een van die secties ooit op een andere pagina,
     dan hoort deze selector meteen strakker. */
  var SELECTOR = '[data-solza-duurz], [data-solza-kaartknop]';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest(SELECTOR);
    if (!link) return;

    var naam = link.getAttribute('data-solza-duurz');
    if (!naam) {
      naam = 'blog:' + (link.getAttribute('data-solza-kaartknop') || 'onbekend');
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'solza_duurzaamheid_klik',
      duurzaamheid: {
        /* Welk onderdeel, wat er staat en waar het heen gaat. Geen
           persoonsgegevens; dit is genoeg om te zien welke ingang werkt. */
        onderdeel: naam,
        tekst: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
        bestemming: link.getAttribute('href') || ''
      }
    });
  });
})();
